import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@dx/web/shared/environments';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageService } from '../shared/services/storage.service';

export const BYPASS_TOKEN = new HttpContextToken(() => false)

@Injectable()
export class HttpTokenInjector implements HttpInterceptor {
  constructor(
    private storage: StorageService,
    private router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith(environment.serverUrl)) {
      request = request.clone({ withCredentials: true });
    }

    return next.handle(request).pipe(
      catchError(error => {
        if (error.status === 401) {
          this.storage.clear();
          this.router.navigate(['auth/login']);
        }
        return throwError(() => error)
      })
    );
  }
}
